// extracted by mini-css-extract-plugin
export default {"manage-clients-grid-popup-client-name":"manage-clients-grid_manage-clients-grid-popup-client-name__GyYwE"};